"use strict";

window.addEventListener('DOMContentLoaded', function (event) {
  var pageAnchorNav = document.querySelector('.anchor-nav__wrapper');
  //Fixed in-page navigation 
  if (pageAnchorNav) {
    var mediaQueryUnder = window.matchMedia('(max-width: 991px)');
    // Highlight active in-page links 
    var allJumpLinks = document.querySelectorAll('.anchor-nav__wrapper ul li');
    allJumpLinks.forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        allJumpLinks.forEach(function (link) {
          link.classList.remove("active");
        });
        this.classList.add("active");
      });
    });
    if (mediaQueryUnder.matches) {
      // Sticky mobile in-page nav
      window.addEventListener('scroll', function (event) {
        var navElem = document.querySelector('.anchor-nav__wrapper');
        var rect = navElem.getBoundingClientRect().top;
        var scroll = window.scrollY;
        if (scroll >= rect) {
          pageAnchorNav.classList.add("anchor-nav__wrapper--stick");
        } else if (scroll <= rect) {
          pageAnchorNav.classList.remove("anchor-nav__wrapper--stick");
        }
      });
    }
  }
});
window.addEventListener('DOMContentLoaded', function (event) {
  var pageAnchorNav = document.querySelector('.multispecialty-anchor-nav__wrapper');
  //Fixed in-page navigation 
  if (pageAnchorNav) {
    var mediaQueryUnder = window.matchMedia('(max-width: 991px)');
    // Highlight active in-page links 
    var allJumpLinks = document.querySelectorAll('.multispecialty-anchor-nav__wrapper ul li');
    allJumpLinks.forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        allJumpLinks.forEach(function (link) {
          link.classList.remove("active");
        });
        this.classList.add("active");
      });
    });
    if (mediaQueryUnder.matches) {
      // Sticky mobile in-page nav
      window.addEventListener('scroll', function (event) {
        var navElem = document.querySelector('.multispecialty-anchor-nav__wrapper');
        var rect = navElem.getBoundingClientRect().top;
        var scroll = window.scrollY;
        if (scroll >= rect) {
          pageAnchorNav.classList.add("multispecialty-anchor-nav__wrapper--stick");
        } else if (scroll <= rect) {
          pageAnchorNav.classList.remove("multispecialty-anchor-nav__wrapper--stick");
        }
      });
    }
  }
});